const en = {
  hero: {
    eyebrow: 'Florist & Balloon Decorator · Jessup, Maryland',
    title: 'Flowers & Balloons for Every Celebration',
    subtitle:
      'Expert floral designs and professional balloon decorations for weddings, quinceañeras, corporate events and celebrations. Serving Howard, Anne Arundel and Prince George’s County. Same-day service available.',
    primary: 'Book Flowers & Balloons',
    secondary: 'View Our Work',
    call: 'Call (240) 413-8201',
    imageAlt:
      'Pastel balloon garland with daisy balloons framing a pink storybook house backdrop for a first birthday',
  },
  trust: ['5.0★ Rated', 'Expert Design', 'Same-Day Service', 'Professional Installation', 'Se habla español'],
  why: {
    eyebrow: 'Why choose us',
    title: 'Two crafts, one team, zero stress',
    lead: {
      title: 'Expert Design',
      body: 'Years of experience in floral design and balloon artistry. We create stunning arrangements and installations that match your vision perfectly — whether that’s a garden ceremony or a pastel birthday wonderland.',
    },
    items: [
      {
        title: 'Professional Installation',
        body: 'We handle all setup on-site. Your decorations are perfect and ready before the first guest arrives.',
      },
      {
        title: 'Same-Day Service Available',
        body: 'Rush orders are possible when flowers are in season. Last-minute arrangements are our specialty.',
      },
      {
        title: 'Bilingual & Personal Service',
        body: 'English and Spanish speaking team. We understand your vision and bring it to life with care.',
      },
      {
        title: 'Affordable Luxury',
        body: 'Premium florals and balloons at prices that work for your budget. Beautiful doesn’t have to mean expensive.',
      },
    ],
  },
  services: {
    title: 'Our Services',
    description:
      'Three floral services, three balloon services — mix them however your celebration needs.',
    viewAll: 'Compare all services',
  },
  work: {
    title: 'Recent Work — Flowers & Balloons',
    description: 'Real events we designed and installed across Maryland.',
    viewAll: 'View full portfolio',
    viewProject: 'View project',
  },
  reviews: {
    title: 'What Our Clients Say',
    viewAll: 'Read all reviews',
    prev: 'Previous reviews',
    next: 'Next reviews',
  },
  process: {
    title: 'From First Message to Final Setup',
    description:
      'Four steps, no surprises. Most clients book three to eight weeks ahead; rush orders are possible when flowers are in season.',
    cta: 'See how it works',
  },
}

const es: typeof en = {
  hero: {
    eyebrow: 'Floristería y Decoración con Globos · Jessup, Maryland',
    title: 'Flores y Globos para Cada Celebración',
    subtitle:
      'Diseños florales expertos y decoraciones de globos profesionales para bodas, quinceañeras, eventos corporativos y celebraciones. Con base en Jessup, Maryland. Servicio el mismo día disponible.',
    primary: 'Reservar Flores y Globos',
    secondary: 'Ver Nuestro Trabajo',
    call: 'Llamar (240) 413-8201',
    imageAlt:
      'Guirnalda de globos pastel con globos de margarita enmarcando una casita rosa para un primer cumpleaños',
  },
  trust: [
    'Calificado 5.0★',
    'Diseño Experto',
    'Servicio Mismo Día',
    'Instalación Profesional',
    'English & Español',
  ],
  why: {
    eyebrow: 'Por qué elegirnos',
    title: 'Dos artes, un equipo, cero estrés',
    lead: {
      title: 'Diseño Experto',
      body: 'Años de experiencia en diseño floral y artesanía de globos. Creamos arreglos e instalaciones que reflejan su visión — ya sea una ceremonia en el jardín o un cumpleaños en tonos pastel.',
    },
    items: [
      {
        title: 'Instalación Profesional',
        body: 'Manejamos toda la instalación en el sitio. Todo queda perfecto antes de que llegue el primer invitado.',
      },
      {
        title: 'Servicio Mismo Día Disponible',
        body: 'Los pedidos urgentes son posibles cuando hay flores en temporada. Los arreglos de último momento son nuestra especialidad.',
      },
      {
        title: 'Servicio Bilingüe y Personal',
        body: 'Equipo que habla inglés y español. Entendemos su visión y la hacemos realidad con cariño.',
      },
      {
        title: 'Lujo Asequible',
        body: 'Flores y globos de calidad premium a precios que se ajustan a su presupuesto.',
      },
    ],
  },
  services: {
    title: 'Nuestros Servicios',
    description:
      'Tres servicios florales y tres de globos — combínelos como su celebración lo necesite.',
    viewAll: 'Comparar todos los servicios',
  },
  work: {
    title: 'Trabajos Recientes — Flores y Globos',
    description: 'Eventos reales que diseñamos e instalamos en Maryland.',
    viewAll: 'Ver portafolio completo',
    viewProject: 'Ver proyecto',
  },
  reviews: {
    title: 'Lo Que Dicen Nuestros Clientes',
    viewAll: 'Leer todas las reseñas',
    prev: 'Reseñas anteriores',
    next: 'Siguientes reseñas',
  },
  process: {
    title: 'Desde el Primer Mensaje hasta la Instalación Final',
    description:
      'Cuatro pasos, sin sorpresas. La mayoría de los clientes reservan de tres a ocho semanas de anticipación.',
    cta: 'Ver cómo funciona',
  },
}

export const home = { en, es }
